import React, { useEffect, useState } from 'react'
import { Button } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { getByIdAndroidAppAction } from '../../redux/Action/AndroidAppAction';
import { GET_BY_ID_ANDROID_APP } from '../../redux/type';
import moment from 'moment';
import Loading from '../../layout/Loading'
import Logo from '../../assets/img/CloseLogo.png'
import { ApiGet } from '../../helper/API/ApiData';
import axios from 'axios';
import { toast } from 'react-toastify';
import ViewJsonUrlApp from '../../components/modals/ViewJsonData';

const ViewAndroid = () => {

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { id } = useParams()
    const [allAndroidData, setAllAndroidData] = useState()
    const [jsonModal, setJsonModal] = useState(false)
    const [jsonData, setJsonData] = useState()
    const getByIdAndroid = useSelector(state => state.androidapp.getbyidapp)
    const loading = useSelector(state => state.androidapp.loading)

    useEffect(() => {
        if (id) {
            dispatch(getByIdAndroidAppAction(id))
        }
    }, [id])

    const handleJsonUrlClick = async () => {
        console.log('handleclick')
        if (getByIdAndroid?.data?.jsonUrl) {
            return await axios.get(getByIdAndroid.data.jsonUrl)
                .then((res) => {
                    if (res && res.status === 200) {
                        console.log('res.status', res.status)
                        setJsonData(res.data)
                        setJsonModal(true)
                    }
                })
                .catch((err) => toast.error('something went wrong'))
        }
    }

    console.log('jsonModal', jsonModal)

    useEffect(() => {
        if (getByIdAndroid) {
            let data = Object.keys(getByIdAndroid.data).filter(ele => !['_id', '__v', 'isDeleted', 'isFavorite', 'extraFields'].includes(ele)).map(key => {
                if (['createdAt', 'updatedAt'].includes(key)) {
                    return ({ key: key, value: moment(getByIdAndroid.data[key]).format('DD.MM.YYYY') })
                }
                if (getByIdAndroid.data[key] && typeof getByIdAndroid.data[key] === "object") {
                    return Object.keys(getByIdAndroid.data[key]).filter(ele => !['_id', '__v', 'isDeleted'].includes(ele)).map(key_ele => {
                        return ({ key: `${key}`, value: getByIdAndroid.data[key][key_ele] })
                    })
                } else {
                    return ({ key: key, value: getByIdAndroid.data[key] })
                }
            }).flat(1)
            if (getByIdAndroid.data?.extraFields) {
                const extraFields = Object.keys(getByIdAndroid.data.extraFields).map((ele) => {
                    return {
                        key: [ele],
                        value: getByIdAndroid.data.extraFields[ele],
                    }
                })
                data = [...data, ...extraFields]
            }
            setAllAndroidData(data)
        }
    }, [getByIdAndroid])

    useEffect(() => {
        return () => {
            dispatch({
                type: GET_BY_ID_ANDROID_APP,
                payload: ''
            })
        }
    }, [])

    console.log('jsonModal', jsonModal)
    return (
        <>
            {loading ? <Loading /> : (
                <div className='android-main'>
                    <div className='android-main-card p-0'>
                        <div className='card__header'>
                            <div style={{ display: 'flex', gap: '20px', alignItems: 'center', flexWrap: 'wrap' }}>
                                <img src={getByIdAndroid?.data?.logo || Logo} alt="" width="30px" />
                                <h1 className='title'>
                                    {getByIdAndroid?.data?.name}
                                </h1>
                            </div>
                            <div className='header_buttons'>
                                <Button className='header_cancel_button' onClick={() => navigate(`/edit-android/${id}`)}>Edit</Button>
                                <Button className='header_cancel_button' onClick={() => navigate('/android')}>Back</Button>
                            </div>
                        </div>
                        <table className='view_table'>
                            <tbody style={{ display: 'flex', flexWrap: 'wrap' }}>
                                {
                                    allAndroidData && allAndroidData.filter(ele => ele.key !== 'logo' && ele.key !== 'name').map((item) => {
                                        return (
                                            <tr key={item.key} style={{ width: '50%', display: 'flex', justifyContent: 'space-around' }}>
                                                <td>{item.key}</td>
                                                <td>
                                                    {item.key === "jsonUrl" ?
                                                        <span
                                                            className='app_json_url_cell'
                                                            onClick={handleJsonUrlClick}>
                                                            {item.value}
                                                        </span> : item.value
                                                    }
                                                </td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
            <ViewJsonUrlApp show={jsonModal} onHide={() => setJsonModal(false)} data={jsonData} />
        </>
    )
}

export default ViewAndroid